import TrustReason from './TrustReason';
export default TrustReason;
